import type { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import SoundCSSTransition from '../../components/atoms/SoundCSSTransition.Container';
import Text from '../../components/atoms/Text';
import Image from '../../components/atoms/Image';
import NextMapLayer from '../../components/molecules/NextMapLayer';
import SpeechBubble from '../../components/atoms/SpeechBubble';
import AutofitText from '../../components/molecules/AutofitText';
import Assets from '../../assets/Assets';

export interface Props {
	onNext: () => void;
}

const FeedbackIntroScreen: FunctionComponent<Props> = (props: Props) => {
	const { onNext } = props;
	const { t } = useTranslation();

	return (
		<>
			{/* Narrator */}
			<>
				<SoundCSSTransition
					classNames="narrator"
					soundUrl={Assets.sounds.personMoves}
					timeout={1_000}
					mountOnEnter
				>
					<Image
						src={Assets.images['narrator.body']}
						width="26vmin"
						height="38vmin"
						position="absolute"
						left="3%"
						bottom="0"
					/>
				</SoundCSSTransition>
				<SpeechBubble
					anchor="left_bottom"
					width="30%"
					height="34%"
					position="absolute"
					left="30vmin"
					bottom="14vmin"
					fadeInDelay={1_000}
					fadeInDuration={300}
				>
					<AutofitText>
						<Text
							content={t('introduction.feedback.description', {
								returnObjects: true
							})}
						/>
					</AutofitText>
				</SpeechBubble>
			</>
			<NextMapLayer text={t('introduction.feedback.next')} onNext={onNext} />
		</>
	);
};

export default FeedbackIntroScreen;
